// The component kit's own copy. Every string a component can render without being handed one by
// the app lives here, so no user-facing string is hard-coded in @clavian/ui-web or
// @clavian/ui-native (spec/21 §3).
//
// Voice: precise, plain, confident, a little dry (BRAND.md §6). A control says exactly what it
// does; a result confirms it. No emoji, no exclamation marks.
export const ui = {
    close: 'Close',
    clear: 'Clear',
    cancel: 'Cancel',
    confirm: 'Confirm',
    loading: 'Loading',
    busy: 'Working',
    required: 'Required',
    optional: 'Optional',
    dismiss: 'Dismiss',
    more: 'More',
    // A dialog with unsaved changes asks before a dismiss throws them away (Dialog `dirty`).
    dialog: {
        discardTitle: 'Discard your changes?',
        discardBody: 'What you changed here has not been saved.',
        keepEditing: 'Keep editing',
        discard: 'Discard',
    },
    select: {
        placeholder: 'Choose one',
        empty: 'Nothing to choose from',
    },
    table: {
        empty: 'Nothing here yet',
        sortedAscending: 'Sorted, lowest first',
        sortedDescending: 'Sorted, highest first',
        sortAscending: 'Sort lowest first',
        sortDescending: 'Sort highest first',
    },
    field: {
        error: 'Check this field',
        describedByError: 'Error',
    },
    switch: {
        on: 'On',
        off: 'Off',
    },
    toast: {
        region: 'Notifications',
    },
    stepper: {
        label: 'Progress',
        stepOf: 'Step {{current}} of {{total}}',
        complete: 'Done',
        current: 'Current step',
        upcoming: 'Not started',
    },
    // A guided tour's bubble (Tour): where it is, and the way on, back and out.
    tour: {
        stopOf: '{{current}} of {{total}}',
        next: 'Next',
        back: 'Back',
        skip: 'Skip tour',
        done: 'Done',
        close: 'Close the tour',
    },
    stat: {
        up: 'Up {{value}}',
        down: 'Down {{value}}',
        flat: 'No change',
        trend: 'Trend',
    },
    chart: {
        showTable: 'Show as a table',
        showAll: 'Show all {{count}}',
        showFewer: 'Show fewer',
    },
    live: 'Live',
    you: 'You',
    rank: 'Rank {{rank}}',
    tier: 'Tier {{tier}}',
    menu: 'Actions',
    remove: 'Remove {{label}}',
    // A list of simple values edited as chips (ChipListEditor).
    chips: {
        add: 'Add',
        duplicate: '{{value}} is already in the list.',
        full_one: 'The list holds at most {{count}} item.',
        full_other: 'The list holds at most {{count}} items.',
        suggestions: 'Add a common one',
    },
    progress: '{{value}}% complete',
    tracker: {
        count: '{{done}} of {{total}}',
        allDone: 'All done.',
    },
    infoTip: {
        label: 'More information',
    },
    formSection: {
        more: 'More options',
        fewer: 'Fewer options',
    },
    venuePicker: {
        inUse: '{{inUse}} of {{total}} PCs in use',
        status: {
            open: 'Open now',
            setup: 'Setting up',
            paused: 'Paused',
        },
    },
    switching: {
        eyebrow: 'Opening',
        title: 'Opening {{name}}',
    },
    presence: {
        online: 'Online',
        away: 'Away',
        playing: 'Playing',
        offline: 'Offline',
    },
    status: {
        free: 'Free',
        session: 'In session',
        ending: 'Ending soon',
        overdue: 'Overdue',
        offline: 'Offline',
        maintenance: 'Maintenance',
    },
};
export default ui;
//# sourceMappingURL=ui.js.map